import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { ArrowDownward } from "@mui/icons-material";

import InfoCard from "./InfoCard";

export default function MyJourney({ cropName }) {
  return (
    <Box sx={{ marginTop: 2 }} id={`my-journey`}>
      <Box sx={{ textAlign: "center" }}>
        <img src={`/SeeMyJourneyText.jpeg`} alt={``} width={300} height={76} />
      </Box>
      <Box sx={{ textAlign: "center", ml: -1 }}>
        <img
          src={`https://static.agrostar.in/output/journeys/${cropName}.jpg`}
          alt={``}
          width={340}
          height={720}
        />
      </Box>
    </Box>
  );
}
